<template>
  <div class="storeManage-list">
    <GlobalInfoBar title="用户列表" content="C端回收小程序用户列表" />
    <GlobalChunkNo icon="search" title="筛选查询">
      <div slot="filter">
        <storeManageFrom />
      </div>

      <storeManageTable />
    </GlobalChunkNo>
  </div>
</template>

<script>
import storeManageFrom from "./From";
import storeManageTable from "./Table";
export default {
  name: "storeManage-list",
  components: { storeManageFrom, storeManageTable },
  data() {
    return {
      userName: "",
      userPhone: "",
      roleId: "",
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.merchant-list {
}
</style>
